/* eslint-disable no-restricted-imports */
import { DEFAULT_GUTTER } from '@crehana/ui/dist/GridV2/Default/constants';
import { Gutter } from '@crehana/ui/dist/GridV2/types';

export const initialStatePageKey = 'searchLanding';

export const SEARCH_LANDING_PAGE_KEY = 'search-landing';
export const SEARCH_LANDING_AMPLITUDE_PAGE_NAME = 'Search Landing';

export const COURSES_PER_PAGE = 12;
export const COURSES_PER_ROW = {
  xs: 1,
  sm: 3,
  md: 4,
  lg: 4,
};
export const PHONE_LEAD_CARD_POSITION = 3;

export const CUSTOM_GRID_GUTTER = { ...DEFAULT_GUTTER, xs: 24 as Gutter };
